/**
 * get css variable from root
 * @param variableName
 * @param element
 */
export function getCssVariableValue(variableName: string, element: HTMLElement = document.documentElement): string {
  return getComputedStyle(element).getPropertyValue(variableName).trim();
}
